import { useAuth0 } from "@auth0/auth0-react";
import { ReactComponent as Close } from "assets/icons/close.svg";
import { CreditCard } from "pages/NewFinance/NewCharge/PaymentMethods/CreditCard";
import React, { useEffect, useState } from "react";

import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Loader from "components/loader/Loader";
import { useFormik } from "formik";

import { useDisableEnterKey } from "hook";
import FinanceService from "Lib/API/Finance/index";
import { ACH } from "pages/NewFinance/NewCharge/PaymentMethods/ACH";
import { toastr } from "react-redux-toastr";
import Button from "../button/Button";
import {
  CloseButton,
  ManagePaymentMethodsActions,
  ManagePaymentMethodsContainer,
  ManagePaymentMethodsContent,
  ManagePaymentMethodsFooter,
  ManagePaymentMethodsHeader,
  ManagePaymentMethodsTitle,
} from "./Theme";
const ManagePaymentMethods = ({ closeModal, accountId, handlePaymentOpen }) => {
  const { getAccessTokenSilently } = useAuth0();

  const [expanded, setExpanded] = useState(null);
  const [selected, setSelected] = useState(null);
  const [selectedAch, setSelectedAch] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [enableAddCard, setEnableAddCard] = useState(false);

  const formik = useFormik({
    enableReinitialize: false,
    initialValues: {},
    validationSchema: "",
  });

  const getMethods = async () => {
    const token = await getAccessTokenSilently();
    setIsLoading(true);
    FinanceService.getPaymentMethods(token)
      .then((res) => {
        const paymentMethods = res?.result
          ?.map((item) => {
            if (item?.type === "credit card") {
              return {
                id: "credit_card",
                title: "Credit Card",
                type: "credit_card",
                component: (
                  <CreditCard
                    accountId={accountId}
                    enableInstallments={false}
                    paymentGateway={item?.paymentGateway}
                    setEnableAddCard={setEnableAddCard}
                    source="managePayments"
                  />
                ),
              };
            } else if (item?.type === "ach") {
              return {
                id: "ach",
                title: "ACH",
                type: "ach",
                component: (
                  <ACH
                    accountId={accountId}
                    source="managePayments"
                    setEnableAddCard={setEnableAddCard}
                    paymentGateway={item?.paymentGateway}
                  />
                ),
              };
            }
          })
          ?.filter((item) => item !== undefined);
        setPaymentMethods(paymentMethods);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  useEffect(() => {
    getMethods();
  }, [accountId]);

  useDisableEnterKey(true);

  return (
    <ManagePaymentMethodsContainer>
      <CloseButton onClick={closeModal}>
        <Close />
      </CloseButton>
      <ManagePaymentMethodsHeader>
        <ManagePaymentMethodsTitle>Payment Methods</ManagePaymentMethodsTitle>
      </ManagePaymentMethodsHeader>
      <ManagePaymentMethodsContent>
        {isLoading ? (
          <Loader />
        ) : (
          paymentMethods.map((item, index) => (
            <div className="mb-1 cash-accordian" key={index}>
              <div className="finance-accordian-container">
                <Accordion
                  className={"finance-accordian"}
                  expanded={expanded === item.id}
                  onChange={(index, newExpanded) => {
                    setExpanded(newExpanded ? item.id : "");
                  }}
                >
                  <AccordionSummary
                    className={
                      expanded === item.id
                        ? "finance-accordian-header-expanded"
                        : "finance-accordian-header"
                    }
                    expandIcon={
                      <ExpandMoreIcon
                        style={
                          !expanded
                            ? { color: "#b5b5c3" }
                            : { color: "#ffffff" }
                        }
                      />
                    }
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    {item.title}
                  </AccordionSummary>
                  <AccordionDetails className="finance-accordian-body">
                    <Typography>
                      {React.cloneElement(item.component, {
                        formik,
                        accountId,
                        onPaymentValueChange: () => { },
                        title: item.id,
                        selected,
                        setSelected,
                        selectedAch,
                        setSelectedAch,
                      })}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </div>
            </div>
          ))
        )}
      </ManagePaymentMethodsContent>
      <ManagePaymentMethodsFooter>
        <hr />
        <ManagePaymentMethodsActions>
          <Button
            onClick={handlePaymentOpen}
            variant="primary"
            size="md"
            style={{ minWidth: "100px" }}
          >
            <span>Share Update Payment Methods Link</span>
          </Button>
          <Button
            onClick={() => {
              closeModal();
            }}
            variant="primary"
            size="md"
            style={{ minWidth: "100px" }}
            disabled={enableAddCard && expanded}
          >
            <span>Done</span>
          </Button>
        </ManagePaymentMethodsActions>
      </ManagePaymentMethodsFooter>
    </ManagePaymentMethodsContainer>
  );
};

export default ManagePaymentMethods;